import React from "react"
import { DropdownItem } from "Components/ReactstrapSlim"
import { HeaderColumnCount, HeaderColumnMenu } from "./HeaderColumnMenu"

export const ConfigurationMenu: React.FC<{ columnCount?: HeaderColumnCount }> = ({ columnCount }) => {
   return (
      <>
         <DropdownItem header>Configuration</DropdownItem>
         <HeaderColumnMenu columnCount={columnCount} fixedWidth={"lg"}>
            <DropdownItem tag="a" href="/resource">Amenities</DropdownItem>
            <DropdownItem tag="a" href="/diagnostics2/workspace-scenarios">Workspace Types</DropdownItem>
            <DropdownItem tag="a" href="/dynamicsearchroute">Dynamic Search Routes</DropdownItem>
            <DropdownItem tag="a" href="/electronicsignature">eSignatures</DropdownItem>
            <DropdownItem tag="a" href="/internationalconfiguration">International Configuration</DropdownItem>
            <DropdownItem tag="a" href="/diagnostics2/api-clients">API Clients</DropdownItem>
         </HeaderColumnMenu>
      </>)
}